import React from 'react';
import styled from 'styled-components';
import { IoClose } from 'react-icons/io5';
import ProjectImg from '../assets/images/projectImg.png';

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.9);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 2rem;
  animation: fadeIn 0.3s ease;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

const ModalContent = styled.div`
  background-color: var(--dark-bg);
  border-radius: 12px;
  max-width: 900px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  position: relative;
  animation: slideUp 0.3s ease;
  border: 2px solid var(--gray-2);

  @keyframes slideUp {
    from {
      transform: translateY(50px);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }

  .modal-image {
    width: 100%;
    height: 400px;
    overflow: hidden;
    border-radius: 12px 12px 0 0;
    
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .modal-info {
    padding: 2rem 3rem 3rem;
    background-color: var(--deep-dark);
  }

  .modal-title {
    font-size: 3rem;
    color: var(--primary);
    margin-bottom: 1.5rem;
  }

  .modal-desc {
    font-size: 1.8rem;
    font-family: Futura, 'Trebuchet MS', Arial, sans-serif;
    color: var(--gray-1);
    line-height: 1.6;
    margin-bottom: 2rem;
  }

  .modal-link {
    display: inline-block;
    font-size: 1.6rem;
    color: var(--primary);
    font-family: Futura, 'Trebuchet MS', Arial, sans-serif;
    text-decoration: none;
    padding: 1rem 2rem;
    border: 2px solid var(--primary);
    border-radius: 8px;
    transition: all 0.3s ease;

    &:hover {
      background-color: var(--primary);
      color: var(--black);
    }
  }

  @media only screen and (max-width: 768px) {
    max-width: 95%;
    
    .modal-image {
      height: 250px;
    }

    .modal-info {
      padding: 1.5rem 2rem 2rem;
    }

    .modal-title {
      font-size: 2.4rem;
    }

    .modal-desc {
      font-size: 1.6rem;
    }
  }
`;

const CloseButton = styled.button`
  position: absolute;
  top: 1rem;
  right: 1rem;
  background-color: rgba(0, 0, 0, 0.7);
  border: none;
  color: white;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2.4rem;
  transition: all 0.3s ease;
  z-index: 10;

  &:hover {
    background-color: var(--primary);
    color: var(--black);
    transform: scale(1.1);
  }
`;

function ProjectModal({
  isOpen,
  onClose,
  img = ProjectImg,
  title = 'Project Name',
  desc = 'Project description',
  link = null,
}) {
  if (!isOpen) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <ModalOverlay onClick={handleOverlayClick}>
      <ModalContent>
        <CloseButton onClick={onClose} aria-label="Fermer">
          <IoClose />
        </CloseButton>
        <div className="modal-image">
          <img src={img} alt={title} />
        </div>
        <div className="modal-info">
          <h2 className="modal-title">{title}</h2>
          <p className="modal-desc">{desc}</p>
          {link && (
            <a
              href={link}
              target="_blank"
              rel="noopener noreferrer"
              className="modal-link"
            >
              Voir le projet →
            </a>
          )}
        </div>
      </ModalContent>
    </ModalOverlay>
  );
}

export default ProjectModal;
